/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const BellIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M19.7916667,16.0652174 L19.7916667,11.0434783 C19.7916667,7.70995652 17.6750833,4.87495652 14.7124167,3.77656522 C14.5098333,2.4636087 13.375,1.45652174 12,1.45652174 C10.625,1.45652174 9.4865,2.4636087 9.28391667,3.77656522 C6.32125,4.87495652 4.20833333,7.70995652 4.20833333,11.0434783 L4.20833333,16.0652174 C4.20833333,17.5781304 2.97633333,18.8043478 1.45833333,18.8043478 L22.5416667,18.8043478 C21.0209167,18.8043478 19.7916667,17.5781304 19.7916667,16.0652174 Z" />
      <path d="M14.75,18.8043478 C14.75,20.3172609 13.518,21.5434783 12,21.5434783 C10.47925,21.5434783 9.25,20.3172609 9.25,18.8043478" />
    </g>
  </svg>
);

export default BellIcon;
